import { render, staticRenderFns } from "./CollectingInstitutionList.vue?vue&type=template&id=71740f36&"
import script from "./CollectingInstitutionList.vue?vue&type=script&lang=js&"
export * from "./CollectingInstitutionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports